import axiosInstance from '../../main/axios';

export async function getPlanosControlador(numControlador, grupoFisico) {
  return axiosInstance.get(`/planos/controlador/numero/${numControlador}/${grupoFisico}`);
}

export async function informacoesPlano(numControlador, grupoFisico, planoId) {
  return axiosInstance.get(`/programacoes_planos/${numControlador}/${grupoFisico}/${planoId}`);
}

export async function trocaPlanos(numControlador, planoId) {
  return axiosInstance.get(`/trocaplanos_report_programacao_planos/${numControlador}/${planoId}`);
}

export async function infoFasesConflitantes(numControlador, grupoFisico) {
  return axiosInstance.get(`/controladores/${grupoFisico}/${numControlador}`);
}

/** Todos os anéis do mesmo número (matriz de conflitos + ids por anel). Não usar id único na URL — só retorna um anel. */
export async function infoControladorAggregadoPorNumero(numeroControlador, grupoFisico) {
  const res = await axiosInstance.get(`/controladores/${grupoFisico}`);
  const list = Array.isArray(res.data) ? res.data : [];
  const found = list.find(c => String(c.numero_controlador) === String(numeroControlador));
  return { data: found ? [found] : [] };
}
